module.exports = __webpack_public_path__ + "img/ta_get.a1a64b0.png";